import {Component} from '@angular/core';
import {RouterModule} from '@angular/router';
import {WaButtonDirective} from 'angular-awesome';
import {WaTextDirective} from 'angular-awesome';
import {WaDetailsDirective} from 'angular-awesome';
import {MarkdownComponent} from 'ngx-markdown';
import {WaTagDirective} from 'angular-awesome';
@Component({
	selector:'jwebmp-pcomp-bsfile-upload',
	templateUrl:'./BSFileUploadPluginCompPage.html',
	styles: [],
	styleUrls:['./BSFileUploadPluginCompPage.scss'
],
	viewProviders:[],
	animations:[],
	providers:[],
	schemas:[],
	preserveWhitespaces:true,
	host:{},
	imports:[
		RouterModule,
		WaButtonDirective,
		WaTextDirective,
		WaDetailsDirective,
		MarkdownComponent,
		WaTagDirective,
],
	standalone:true
})
export class BSFileUploadPluginCompPage
{
	mdContent_818 = `\`\`\`java
import com.jwebmp.plugins.bootstrap.fileupload.BSFileUpload;
\`\`\``;
	mdContent_819 = `\`\`\`java
BSFileUpload()
\`\`\``;
	mdContent_820 = `\`\`\`java
BSFileUpload&lt;?&gt; upload = new BSFileUpload&lt;&gt;();
upload.setLabel("Upload documents");
upload.setMultiple(true);
upload.setAccept(".pdf,.docx");
\`\`\``;
}
